/**
 * Masonry-Raster für Karten mit Text (Blog-Listen).
 *
 * @masonry-grid/vanilla erwartet pro Element ein festes Seitenverhältnis
 * (--width/--height). Für Textkarten wird es aus der natürlichen Höhe
 * gemessen und bei Breitenänderung neu bestimmt.
 */

import { BalancedMasonryGrid } from '@masonry-grid/vanilla';
import { all, onDomReady } from '../utils/dom';

const RATIO_BASE = 1000;

/**
 * @param {HTMLElement} grid
 */
function measure(grid) {
    const items = grid.querySelectorAll(':scope > .masonry-item');

    grid.classList.add('is-measuring');

    const ratios = Array.from(items, (item) => Math.round((item.offsetHeight / item.offsetWidth) * RATIO_BASE));

    grid.classList.remove('is-measuring');

    items.forEach((item, i) => {
        item.style.setProperty('--width', String(RATIO_BASE));
        item.style.setProperty('--height', String(ratios[i]));
    });
}

/**
 * @param {HTMLElement} grid
 */
function initGrid(grid) {
    let lastWidth = 0;

    const update = () => {
        const width = grid.clientWidth;

        if (width === lastWidth) {
            return;
        }

        lastWidth = width;
        measure(grid);
    };

    update();
    new BalancedMasonryGrid(grid);

    new ResizeObserver(() => update()).observe(grid);
    document.fonts?.ready.then(() => {
        lastWidth = 0;
        update();
    });
}

onDomReady(() => {
    all('.masonry-grid').forEach(initGrid);
});
